import { render, staticRenderFns } from "./locked.vue?vue&type=template&id=5eddbea4&scoped=true"
import script from "./locked.vue?vue&type=script&lang=js"
export * from "./locked.vue?vue&type=script&lang=js"
import style0 from "./locked.vue?vue&type=style&index=0&id=5eddbea4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eddbea4",
  null
  
)

export default component.exports